module.exports = __webpack_public_path__ + "939976c59a8f2c3ae949d5655ab97bba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003BU5.png
// module id = 1524
// module chunks = 0